import { createContext } from 'react';
export var AllhomesGlobalContext = /*#__PURE__*/createContext({});
AllhomesGlobalContext.displayName = 'AllhomesGlobalContext';